var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutozoneBtnLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -10,
    y: -10,
    width: 56,
    height: 56
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      clipPath: "url(#bgblur_0_21207_90770_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 10
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -11.25,
    y: -11.25,
    width: 58.5,
    height: 58.5
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5.62px)",
      clipPath: "url(#bgblur_1_21207_90770_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 11.25
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#14151C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7362 10.6618L7.7334 11.5439V14.8339V18.124L12.7362 17.2419V20.5318L17.739 19.6496V16.3597V13.0697L22.7419 12.1875V8.89755L17.739 9.77968L12.7362 10.6618Z",
    fill: "#0092E4",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7362 17.2416L7.7334 18.1238V21.4138V24.7038V27.9939L12.7362 27.1117L17.739 26.2296L17.739 22.9396L22.7419 22.0574V18.7674V15.4774L17.739 16.3596L17.739 19.6496L12.7362 20.5316V17.2416Z",
    fill: "#9664F0",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7421 12.1874L17.7393 13.0696V16.3596L22.7421 15.4774L22.7421 18.7674L22.7421 22.0574L17.7393 22.9395V26.2295L22.7421 25.3474L27.7449 24.4653V21.1753V17.8853L27.7449 14.5953V11.3053V8.01528L22.7421 8.89741V12.1874Z",
    fill: "#E85D78",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_21207_90770_clip_path",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_21207_90770_clip_path",
    transform: "translate(11.25 11.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutozoneBtnLayers);
export default __webpack_public_path__ + "static/media/autozone-btn-layers.05ad4f604f4cbb2fc5af5e20fe42eb4f.svg";
export { ForwardRef as ReactComponent };